import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtgDraftOrderItemComponent } from './atg-draft-order-item.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule, MediaModule } from '@spartacus/storefront';
import { I18nModule, RoutingModule, UrlModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { KnBrDirectiveModule } from 'src/shared/directive/kn-br-directive.module';


@NgModule({
  declarations: [AtgDraftOrderItemComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    RoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MediaModule,
    NgbModule,
    I18nModule,
    KnBrDirectiveModule,
    FormErrorsModule,
  ],
  exports: [AtgDraftOrderItemComponent],
})
export class AtgDraftOrderItemModule { }
